import { pluck } from "@odmonorepo/odfunctions";
import { Offer } from "merchant-api/types";

export const maxLoanAmount = (offers: Offer[]): number =>
  Math.max(...pluck(offers, 'maxLineAmount'));

export const minLoanAmount = (offers: Offer[]): number =>
  Math.min(...pluck(offers, 'minLineAmount')) > 5000 ? Math.min(...pluck(offers, 'minLineAmount')) : 5100;
